import { ChartBarStackedIcon } from './ChartBarStackedIcon';

/**
 * author: Austin Andrews
 * id FAA40519-5517-44DF-AF2E-30D07874BEB7
 * name chart-bar-stacked
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-bar-stacked.svg
 * tags
 * - Math 
 */
export const ReportBarStackedIcon = ChartBarStackedIcon;
export default ReportBarStackedIcon